export class CommonUtil {
    public static getMaskedEmail(email: string): string {
        if (!email) return '';
        if (email.endsWith('@hiddin.net')) {
            return email;
        }
        const atIdx = email.indexOf('@');
        if (atIdx === -1) return 'xxxxx#gmail.com';
        const domain = email.substring(atIdx + 1);
        return `xxxxx#${domain}`;
    }

    public static getMaskedPhone(phone: string): string {
        if (!phone) return '';
        const digits = phone.replace(/\D/g, '');
        if (digits.length < 2) return 'xxxx';
        const start = digits[0];
        const end = digits[digits.length - 1];
        const xCount = digits.length - 2;
        const xStr = 'x'.repeat(xCount);
        return `${start}${xStr}${end}`;
    }

    public static replaceAll(str: string, from: string | RegExp, to: any) {
        if (this.isEmpty(str)) {
            return str;
        }
        return str.replace(new RegExp(from, 'g'), to);

    }

    public static removeSpecialChars(text: string) {
        return text.replace(/[^a-zA-Z0-9]/g, '');
    }

    public static isNullOrEmptyOrUndefined = function (value: any) {
        return !value;
    }

    public static isEmpty(value: string | any[] | null | undefined) {
        if (value == null || value == undefined || value.length == 0) {
            return true;
        }
        return false;
    }

    public static isEmptyTrim = function(value: string | null | undefined)  {
        if (value == null || value == undefined || value.trim().length == 0) {
            return true;
        }
        return false;
    }

    public static formatPhone = function(phoneNumber: string) {
        if(phoneNumber) {
            return CommonUtil.getX(phoneNumber.length - 4) + phoneNumber.substr(phoneNumber.length - 4);
        }
        return '';
    }

    public static formatEmail = function(email: string) {
        let atIndex = email.indexOf("@");
        if(email) {
            return email.substr(0, 1) + CommonUtil.getX(atIndex - 2).toLowerCase() + email.substr(atIndex-1, 1) + email.substr(atIndex, email.length);
        }
        return '';
    }

    public static getX = function(count: number) {
        let str = "";
        for (let i = 1; i <= count; i++) {
            str += "X";
        }
        return str;
    }
}